import Vue from 'vue'
import { Toast as MintToast } from 'mint-ui'

let current = null

export const closeToast = () => {
  if (current) current.close()
}

// 返回独立句柄，避免 Mint UI 回收实例后，旧句柄关闭新提示。
export default function Toast(options = {}) {
  closeToast()
  const settings = typeof options === 'string' ? { message: options } : options
  const duration = settings.duration === undefined ? 3000 : settings.duration
  const instance = MintToast({ ...settings, duration: -1 })
  const originalClose = instance.close
  let closed = false
  let timer
  const handle = {
    close() {
      if (closed) return
      closed = true
      clearTimeout(timer)
      if (current === handle) current = null
      // 等待 Mint UI 的显示 nextTick，避免关闭后又被其重新显示。
      Vue.nextTick(() => {
        instance.close = originalClose
        originalClose.call(instance)
      })
    }
  }
  current = handle
  Vue.nextTick(() => {
    if (!closed && duration >= 0) timer = setTimeout(handle.close, duration)
  })
  return handle
}
